





























import { namespace } from 'vuex-class';
import {
  Component,
  Prop,
  Provide,
  Vue
} from 'vue-property-decorator';
import { CART, LABEL_SELECTION } from '@/store/types';
import { ConfigService } from '@/services/ConfigService';
import { ProductDeserializer, UnitDefinition } from '@/services/ProductDeserializer';
import {
  EssenceItemDto,
  OrderTemplateDto,
  OrderTemplateItemDto,
  PriceDto,
  ProductAttributeInfo,
  ProductBasePrice, ProductDto,
  ProductNetFillQuantity,
  SalesConditionInfo
} from '@eurogast/hub-client-typescript';
import { PriceDeserializer } from '@/services/PriceDeserializer';
import { LinkUtil } from '@/services/LinkUtil';
import { BooleanService } from '@/services/util/BooleanService';
import Nara from '@/domain/product/Nara';
import { OrderTemplateDeserializer } from '@/services/OrderTemplateDeserializer';
import ResultShoppingCartControl from '@/search-result/ResultShoppingCartControl.vue';
import { OrderTemplateItemDeserializer } from '@/services/OrderTemplateItemDeserializer';
import MatomoContext from '@/matomo/domain/MatomoContext';

const cart = namespace(CART);
const label = namespace(LABEL_SELECTION);

@Component({
  components: {
    ResultShoppingCartControl
  }
})
export default class ProductListItem extends Vue {

  get essences(): EssenceItemDto[] {
    return ConfigService.parseEssence(this.localEssences);
  }

  get orderTemplates(): OrderTemplateDto[] {
    return OrderTemplateDeserializer.parseOrderTemplateList(this.localOrderTemplateList);
  }

  get naras(): Nara[] {
    return Nara.parseNarasJson(this.localNaras);
  }

  get units(): UnitDefinition[] {
    return ConfigService.parseUnits(this.localUnits);
  }

  get sku(): string {
    return this.localSku;
  }

  get attributes(): ProductAttributeInfo[] {
    return ConfigService.parseArray(this.localAttributes)
      .map((source) => ProductDeserializer.parseAttribute(source));
  }

  get virtualCategories(): string[] {
    return ConfigService.parseArray(this.localVirtualCategories);
  }

  get conditions(): SalesConditionInfo[] {
    return ConfigService.parseArray(this.localConditions)
      .map((source) => ProductDeserializer.parseSalesCondition(source));
  }

  get minSaleQuantity(): number {
    return Number.parseFloat(this.localMinSaleQuantity);
  }

  get bulkPrices(): PriceDto[] {
    if (this.localBulkPrices != null) {
      return PriceDeserializer.parsePriceList(this.localBulkPrices).sort((a, b) => a.minQuantity - b.minQuantity);
    } else {
      return [];
    }
  }

  get basePrice(): ProductBasePrice {
    if (this.localBasePrice) {
      return ProductDeserializer.parseBasePrice(this.localBasePrice);
    } else {
      return null;
    }
  }

  get netFillQuantity(): ProductNetFillQuantity {
    if (this.localNetFillQuantity) {
      return ProductDeserializer.parseNetFill(this.localNetFillQuantity);
    } else {
      return null;
    }
  }

  get isEssential() {
    return BooleanService.fromString(this.localEssential);
  }

  get showEssenceButton(): boolean {
    return BooleanService.fromString(this.localEssenceHideButton);
  }

  get highlighted(): boolean {
    return BooleanService.fromString(this.localHighlighted);
  }

  get isPromoted(): boolean {
    return BooleanService.fromString(this.localPromoted);
  }

  get detailUrl(): string {
    return LinkUtil.getProductDetailUrl(this.localProductName, this.localSku);
  }

  get showLabelPrint(): boolean {
    return BooleanService.fromString(this.localShowLabelPrint);
  }

  get showOrderTemplates(): boolean {
    return BooleanService.fromString(this.localShowOrderTemplates);
  }

  get orderTemplateItem(): OrderTemplateItemDto | null {
    return OrderTemplateItemDeserializer.parseOrderTemplateItem(this.localOrderTemplateItem);
  }

  @Prop({ required: true })
  public localSku: string;
  @Prop({ required: true })
  public localMinSaleQuantity: string;
  @Prop({ required: false })
  public localBulkPrices: string;
  @Prop({ required: true })
  public localUnits: string;
  @Prop({ required: true })
  public localAttributes: string;
  @Prop({ required: true })
  public localVirtualCategories: string;
  @Prop({ required: true })
  public localConditions: string;
  @Prop()
  public localNetFillQuantity: string;
  @Prop()
  public localBasePrice: string;
  @Prop({ required: false, default: null })
  public localOrderTemplateItem: string;
  @Prop({ required: false, default: null })
  public localOrderTemplateId: string;
  @Prop({ required: false, default: null })
  public localOrderTemplateList: string;
  @Prop()
  public localImagePath: string;
  @Prop()
  public localProductName: string;
  @Prop()
  public localProductDescription: string;
  @Prop({ default: '' })
  public localEssences: string;
  @Prop()
  public localEssential: string;
  @Prop()
  public localEssenceHideButton: string;
  @Prop({ required: false, default: null })
  public localPromoted: string;
  @Prop({ required: false})
  public localShowLabelPrint?: string;
  @Prop({ required: false})
  public localShowOrderTemplates?: string;
  @Prop()
  public localHighlighted: string;
  @Prop({ required: false, default: '' })
  public localNaras: string;
  @Prop({ required: false, default: ProductDto.AvailabilityEnum.ACTIVE })
  public localAvailability: ProductDto.AvailabilityEnum;

  @Provide()
  public matomoContext = MatomoContext.forProductListItem(this.isPromoted);

}
